import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export const APP_TYPES = {
  ADMIN: 'ADMIN',
  CLIENT: 'CLIENT',
  HIGHLIGHTER: 'HIGHLIGHTER',
} as const;

export type AppTypes = (typeof APP_TYPES)[keyof typeof APP_TYPES];

export interface AppState {
  appType: AppTypes | null;
}

const initialState: AppState = {
  appType: null,
};

export const appTypeSlice = createSlice({
  name: 'appType',
  initialState,
  reducers: {
    /**
     * @description
     * Redux action to set the currently selected app type.
     * @param action `AppTypes` - The app type to set.
     * @example
     * ```ts
     * dispatch(appSliceActions.setAppType(APP_TYPES.ADMIN));
     * ```
     */
    setAppType: (state, action: PayloadAction<AppTypes>) => {
      state.appType = action.payload;
    },
  },
});

// Private actions are used internally by redux-state package only.
// This is to avoid having these values set in unintentional locations.
export const appTypeSlicePrivateActions = {
  setAppType: appTypeSlice.actions.setAppType,
};

// Public actions can be used by any consumer of the redux-state package.
export const appTypeSlicePublicActions = {};

export default appTypeSlice;
